// extracted by mini-css-extract-plugin
export default {"container":"LinkToMain_container__aC94J","text":"LinkToMain_text__HK95W","icon":"LinkToMain_icon__xp1y4"};